<label class="form-labels mt-4">Compañia</label>
<select (change)="updateCompany($event)" class="form-select" [(ngModel)]="companyId">
    <option selected></option>
    <option [value]="company.id" *ngFor="let company of companies">{{ company.name }}
    </option>
</select>